import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { PropTypes } from 'prop-types';
import URL from 'url-parse';
import { window } from '../../../../helpers/BrowserHelpers';
import Favicon from '../../../../components/Favicon';
import { cleanUrl } from '../../../../utils/linkUtils';

var HTTPLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HTTPLink, _React$Component);

  function HTTPLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HTTPLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HTTPLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "openLink", function (event) {
      event.stopPropagation();
      event.preventDefault();
      window.open(cleanUrl(_this.props.url), '_blank');
    });

    return _this;
  }

  _createClass(HTTPLink, [{
    key: "render",
    value: function render() {
      var url = this.props.url;
      var parsedUrl = cleanUrl(url);

      var _ref = new URL(cleanUrl(url)),
          hostname = _ref.hostname;

      var strippedHostname = hostname.replace('www.', '');
      return React.createElement("div", {
        className: "flexbox flexbox-align-center"
      }, React.createElement("div", {
        className: "flexbox flexbox-centered margin-horizontal-small"
      }, React.createElement(Favicon, {
        domain: strippedHostname
      })), React.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: this.openLink,
        className: "underline primary font-weight-medium padding-left-small padding-right-small font-size-normal ellipsis",
        style: {
          maxWidth: 300
        }
      }, parsedUrl));
    }
  }]);

  return HTTPLink;
}(React.Component);

_defineProperty(HTTPLink, "propTypes", {
  url: PropTypes.string
});

export { HTTPLink as default };